import PropTypes from 'prop-types';
import React from 'react';

import Formaters from '../../formatters';

function Money({ amount, currency, locales }) {
    const formater = Formaters.getCurrencyFormatter(locales, currency);
    return (
        <span className="format-money" data-amount={String(amount)}>
            {formater.format(amount)}
        </span>
    );
}

Money.propTypes = {
    amount: PropTypes.number.isRequired,
    currency: PropTypes.string,
    locales: PropTypes.string,
};
Money.defaultProps = {
    currency: 'USD',
    locales: 'en-us',
};

export default Money;
